<template>
  <div>
    <v-navigation-drawer
      v-if="component"
      elevation="2"
      temporary
      v-model="localVisible"
      @input="onDrawerToggled"
      right
      app
      width="500"
      class="main-side-drawer"
    >
      <component :is="component" :visible="visible"/>
    </v-navigation-drawer>
    <div class="modal-wrapper">
      <v-dialog 
        v-model="veda_summary_dialog.show"
      >
          <veda-summary 
            class="summary-wrapper"
            :veda-report="veda_report"
            :showFullReportButton="false"
            :showPerfectScoreButton="false"
          />
      </v-dialog>
    </div>
  </div>
</template>

<script>
import LiveAuctionPanel from "@/components/SideDrawer/LiveAuctionPanel.vue";
import VedaSummary from '@/components/ApplicationSummary/VedaSummary.vue';
import { mapGetters } from "vuex";

export default {
  name: "MainSideDrawer",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    activeDrawerType: {
      type: String,
      default: null,
    },
  },
  components: {
    LiveAuctionPanel,
    VedaSummary
  },
  data() {
    return {
      localVisible: this.visible,
      component: null
    };
  },
  computed: {
    ...mapGetters(["veda_report", "veda_summary_dialog"])
  },
  mounted() {
    if (this.activeDrawerType) {
      this.getComponent(this.activeDrawerType);
    }
  },
  watch : {
    visible(val) {
      this.localVisible = val;
    },
    activeDrawerType(val) {
      this.getComponent(val);
    }
  },
  methods: {
    onDrawerToggled(val) {
      this.localVisible = val;
      this.$emit("update:visible", val);
      this.$store.commit("set_show_live_auction_drawer", val);
    },
    async getComponent(drawerType){
      if (drawerType == 'Live Auctions') { 
        this.component = this.$options.components.LiveAuctionPanel;
      }
    }
  }
};
</script>

<style scoped>
.main-side-drawer {
  z-index: 5555 !important;
  background-color: gainsboro !important;
}

.modal-wrapper {
  z-index: 7777 !important;
  max-width: 50vw;
}

.summary-wrapper {
  background-color: white !important;
  padding: 50px;
}
</style>
